export default __webpack_public_path__ + "static/media/login-background.e4c53b93.png";